import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id D59C885E-233F-4472-AB8C-00C41F96134E
 * name ethereum
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ethereum.svg
 * tags
 * - Brand / Logo 
 */
export const EthereumIcon = createSvgIcon(<><path d="M12,1.75L5.75,12.25L12,16L18.25,12.25L12,1.75M5.75,13.5L12,22.25L18.25,13.5L12,17.25L5.75,13.5Z" /></>, 'EthereumIcon');
export default EthereumIcon